<template>
  <b-table-simple
    bordered
    responsive
    sticky-header
    class="mt-2"
    style="max-height: 65vh; font-size: 12px;"
  >
    <colgroup>
      <col style="width: 120px">
      <col style="width: 120px">
      <col style="width: 120px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
    </colgroup>
    <b-thead head-variant="light">
      <b-tr>
        <b-th
          rowspan="2"
          style="text-align: center;"
        >지역</b-th>
        <b-th
          rowspan="2"
          style="text-align: center;"
        >일자</b-th>
        <b-th
          rowspan="2"
          style="text-align: center;"
        >진료과</b-th>
        <b-th
          colspan="3"
          style="text-align: center;"
        >라이브 DI 노출 수</b-th>
        <b-th
          colspan="3"
          style="text-align: center;"
        >라이브 DI 클릭 수</b-th>
      </b-tr>
      <b-tr>
        <b-th
          style="text-align: center; top: 40px;"
        >전체</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의사 수</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의원 수</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >전체</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의사 수</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의원 수</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <template v-if="!gridVisible">
        <tr>
          <td
            colspan="9"
            style="text-align: center;"
          >
            라이브 DI 업데이트로 2025-08-28 이전 데이터는 제공되지 않습니다.
          </td>
        </tr>
      </template>
      <template v-else-if="data.length > 0">
        <template v-for="(row, rIdx) in rows">
          <template v-for="(dept, index) in row.liveDiDepts">
            <b-tr
              :key="`daily-${rIdx}-${index}`"
              :style="row.regionName === '(미분류제외) 전체 합' ? 'background-color: rgba(127, 127, 255, 0.1);' : ''"
            >
              <b-td
                v-if="index === 0 && row.isRegionFirst"
                :rowspan="row.regionRowSpan"
                style="text-align: center;"
              >
                {{ /*지역*/ row.regionName }}
              </b-td>
              <b-td
                v-if="index === 0"
                :rowspan="row.liveDiDepts.length + 1"
                style="text-align: center;"
              >
                {{ /*일자*/ row.dateStr }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*진료과*/ dept.medicalDepartmentName }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*전체*/ dept.liveDiStatDetail.totalShowCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의사수*/ dept.liveDiStatDetail.doctorShowCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의원수*/ dept.liveDiStatDetail.hcpShowCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*전체*/ dept.liveDiStatDetail.totalClickCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의사수*/ dept.liveDiStatDetail.doctorClickCount| $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의원수*/ dept.liveDiStatDetail.hcpClickCount | $numberFormatter }}
              </b-td>
            </b-tr>
          </template>
          <b-tr
            :key="`daily-subtotal-${rIdx}`"
            class="h6 font-weight-bolder"
            :style="row.dateStr ? 'background-color: rgba(127, 127, 127, 0.2);' : 'background-color: rgba(127, 255, 127, 0.1);'"
          >
            <b-td
              v-if="row.isRegionFirst && row.liveDiDepts.length === 0"
              :rowspan="row.regionRowSpan"
              style="text-align: center;"
            >
              {{ /*지역*/ row.regionName }}
            </b-td>
            <b-td
              style="text-align: center;"
              :colspan="row.dateStr ? 1 : 2"
            >
              {{ /*소계 구분*/ row.dateStr ? '일자별 소계' : (row.regionName === '(미분류제외) 전체 합' ? '전체 합계' : '지역별 소계') }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 노출 전체*/ row.subTotal.totalShowCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 노출 의사수*/ row.subTotal.doctorShowCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 노출 의원수*/ row.subTotal.hcpShowCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 클릭 전체*/ row.subTotal.totalClickCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 클릭 의사수*/ row.subTotal.doctorClickCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 클릭 의원수*/ row.subTotal.hcpClickCount | $numberFormatter }}
            </b-td>
          </b-tr>
        </template>
      </template>
      <template v-else>
        <tr>
          <td
            colspan="9"
            style="text-align: center;"
          >
            라이브 DI를 선택해 주세요.
          </td>
        </tr>
      </template>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import {
  BTableSimple, BThead, BTr, BTh, BTbody, BTd,
} from 'bootstrap-vue'
import { computed, onMounted } from '@vue/composition-api'

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    gridVisible: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    onMounted(() => {
    })

    // 지역이 같은 연속 행(일자별 행 + 지역 기간 소계 행)을 한 그룹으로 묶음
    const rows = computed(() => {
      const list = props.data || []
      // 한 행이 차지하는 tr 수 = 진료과 행 수 + 소계 행 1
      const trCount = row => row.liveDiDepts.length + 1

      return list.map((row, idx) => {
        const isRegionFirst = idx === 0 || list[idx - 1].regionName !== row.regionName
        let regionRowSpan = 0

        if (isRegionFirst) {
          for (let i = idx; i < list.length && list[i].regionName === row.regionName; i += 1) {
            regionRowSpan += trCount(list[i])
          }
        }

        return { ...row, isRegionFirst, regionRowSpan }
      })
    })

    const useDailyTotal = true
    const useSubTotal = true
    const useMainTotal = false
    const totalLevel = parseInt(useDailyTotal + useSubTotal + useMainTotal, 10)

    return {
      rows,
      totalLevel,
      useDailyTotal,
      useSubTotal,
    }
  },
}
</script>

<style scoped>
.table-bordered th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}
</style>
